document.addEventListener('DOMContentLoaded', function(){
	
	const tabs = document.querySelectorAll('.mpage__tab'),
				mageCalcResultOpenBtn = document.querySelector('.mgcr__open-btn'),
				allCheck = document.querySelectorAll('.mage-offer__table thead .check__input'),
				graphPreloader = document.querySelector('.preloader--mage-table'),
				showAdditionalFieldsBtn = document.querySelector('.mage-else__add-fields .link'),
				additionalFields = document.querySelectorAll('.mage-else__line--additional'),
				mageOffersSubmitBtn = document.querySelectorAll('.mage-offer__submit-btn'),
				pickedOffersInput = document.querySelector('.mage-else__picked-offers-input');

	let mageCalcResultWrp = document.querySelector('.mgcr'),
			calcForm = document.querySelector('.mage-calc__body'),
			stepsPopup = document.querySelector('.popup--mortage-steps'),
			mageOfferTables = document.querySelectorAll('.mage-offer'),
			formPopup = document.querySelector('.popup--mortage-steps'),
			mapContainer = document.querySelector('.mpage__map');

	let pickedOffers,
			mageBankApp;

	function updatePickers() {
		const pickers = document.querySelectorAll('.picker');

		pickers.forEach(function(el){
			pickerObj.rebuildPicker(el);
		});
	}

	function initNewBuildingsSliders() {
		const sliders = document.querySelectorAll('.cli__slider-wrp');

		sliders.forEach(function(slider){
			new Swiper(slider, {
				preloadImages: false,
				lazy: true,
				navigation : {
					nextEl: slider.querySelector('.cli__slider-btn--next'),
					prevEl: slider.querySelector('.cli__slider-btn--prev'),
					disabledClass: 'cli__slider-btn--disabled'
				},
				on: {
					slideChange: function () {
						slider.querySelector('[data-current-index]').textContent = this.realIndex + 1;
					}
				}
			});
		})
	}

	function updateProgramsNative(form) {		

		mageOfferTables.forEach(function(offer){
			const preloader = offer.querySelector('.preloader'),
						table = offer.querySelector('.mage-offer__container');

			let data = new FormData(form);

			preloader.style.display = ''
			table.innerHTML = '';

			data.append('bank', offer.dataset.bank);

			fetch('/data/mortage-offers.html', {
				method: 'post',
				body: data
			}).then(response => {
				return response.text();
			}).then(mortageOffers => {

				preloader.style.display = 'none';
				table.insertAdjacentHTML('beforeend', mortageOffers);
			});
		});
	}

	function showGraphTableNative() {
		const graphTableWrp = document.querySelector('.popup--mortage-table .popup__win');

		const oldTable = graphTableWrp.querySelector('.table-responsive');
		if (oldTable) {
			oldTable.remove();
		}

		const oldLink = graphTableWrp.querySelector('.all-docs-btn');
		if (oldLink) {
			oldLink.remove();
		}
		graphPreloader.style.display = '';

		let data = new FormData(calcForm);

		fetch('/data/mortage-table.html', {
			method: 'post',
			body: data
		}).then(response => {
			return response.text();
		}).then(mortageTable => {
			
			graphPreloader.style.display = 'none';
			graphTableWrp.insertAdjacentHTML('beforeend', mortageTable);

			const dataForDocsInput = document.querySelector('.js-data-for-docs');
			dataForDocsInput.value = JSON.stringify(Object.fromEntries(data));
		}).catch(function(error) {
			console.error(error);
		});
	}

	tabs.forEach(function(tab){

		tab.addEventListener('click', function(){
			
			if (tab.classList.contains('mpage__tab--active')) {
				return;
			}

			let target = tab.dataset.target;      
			const targetEl = document.getElementById(target);

			document.querySelector('.mpage__tab--active').classList.remove('mpage__tab--active');
			tab.classList.add('mpage__tab--active');

			document.querySelector('.mpage__tab-container--active').classList.remove('mpage__tab-container--active');
			targetEl.classList.add('mpage__tab-container--active');
		});
	});

	if (calcForm) {
		document.addEventListener('scroll', function(){
			if (isScrolledIntoView(calcForm) && ( window.innerWidth < 768) ) {
				mageCalcResultWrp.classList.add('mgcr--opened');
			} else {
				mageCalcResultWrp.classList.remove('mgcr--opened');
			}
		});
	}


	document.addEventListener('click', function(e){

		// open more mortage offers
		const moreBtn = e.target.closest('.mage-offer__more-vars-btn');
		if (moreBtn) {
			const bankId = moreBtn.closest('.mage-offer__line').dataset.bank,
					hiddenLines = document.querySelectorAll('.mage-offer__line--hidden[data-bank="'+bankId+'"]');
			let display;

			if (moreBtn.classList.contains('mage-offer__more-vars-btn--opened')) {
				moreBtn.classList.remove('mage-offer__more-vars-btn--opened');
				display = 'none';
			} else {
				moreBtn.classList.add('mage-offer__more-vars-btn--opened');
				display = '';
			}

			let label = moreBtn.textContent;
			moreBtn.textContent = moreBtn.dataset.state;
			moreBtn.dataset.state = label;

			hiddenLines.forEach(function(line){
				line.style.display = display;
			});	
		}


		// get a picked mortage offer
		const getOfferBtn = e.target.closest('.js-single-offer-submit');
		if (getOfferBtn) {
			var input = getOfferBtn.closest('.mage-offer__line')
										.querySelector('.check__input');
			
			pickedOffers = new FormData();
			pickedOffers.append(input.getAttribute('name'), input.value);
			pickedOffersInput.value = JSON.stringify(Object.fromEntries(pickedOffers));

			if (mageBankApp) {
				mageBankApp.step = 'third';
			}
			
			formPopup.classList.add('popup--active');
			document.body.style.overflow = 'hidden';
		}

	});

	mageOffersSubmitBtn.forEach(btn => {
		btn.addEventListener('click', function(e){
			e.preventDefault();

			const form = this.closest('form');
			
			pickedOffers = new FormData(form);
			pickedOffersInput.value = JSON.stringify(Object.fromEntries(pickedOffers));

			if (mageBankApp) {
				mageBankApp.step = 'third';
			}

			formPopup.classList.add('popup--active');
			document.body.style.overflow = 'hidden';
		});
	});

	allCheck.forEach(function(el){
		el.addEventListener('change', function(){

			var offLines = el.closest('.mage-offer__table').querySelectorAll('.mage-offer__line');
			offLines.forEach( function(line){
				if (el.checked) {
					line.classList.add('mage-offer__line--checked');
				} else {
					line.classList.remove('mage-offer__line--checked');
				}

				line.querySelector('.check__input').checked = el.checked;
			});
		});
	});

	document.addEventListener('change', function(e){

		const offLine = e.target.closest('.mage-offer__line');
		if (offLine) {
			const allCheck = offLine.closest('.mage-offer__table').querySelector('thead .check__input');

			offLine.classList.toggle('mage-offer__line--checked');

			if (!e.target.checked) {
				allCheck.checked = false;
			}
		}
	});

	showAdditionalFieldsBtn.addEventListener('click', function(){
		additionalFields.forEach(function(field){
			field.classList.remove('mage-else__line--additional');
			showAdditionalFieldsBtn.parentNode.style.display = 'none';
		});
	});


	const mInput = {
		props: {
			min: {type: Number, default: 0},
			max: {type: Number, default: 0},
			modelValue: {default: ''}
		},
		data() {
			return {
				inputValue: 0
			}
		},
		emits: ['update:modelValue'],
		mounted(){
		},
		// watch: {
		// 	modelValue: function() {
		// 		this.inputValue = new Intl.NumberFormat('ru').format(this.modelValue);
		// 	}
		// },
		computed: {
			value: {
				get() {
					this.inputValue = new Intl.NumberFormat('ru').format(this.modelValue);
					return this.modelValue;
				},
				set(value) {
					// value = Number(value.replace(/\s/g, ''));
					
					this.$emit('update:modelValue', value);
				}
			}
		},
		methods: {
			toNumber() {
				this.inputValue = this.inputValue.replace(/\s/g, '');
			},
			update() {
				this.inputValue = Number(this.inputValue);

				if (this.inputValue > this.max) {
					this.inputValue = this.max;
				}
				if (this.inputValue < this.min) {
					this.inputValue = this.min;
				}

				this.value = this.inputValue;
				this.inputValue = new Intl.NumberFormat('ru').format(this.modelValue);
			},
			isNumber: function(evt) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
					evt.preventDefault();;
				} else {
					return true;
				}
			}
		},
		template: `
			<input
				type="text" class="input-line__input"
				v-model.lazy="inputValue"
				@focus="toNumber()"
				@blur="update()"
				@keypress="isNumber($event)"
			>
			<input
				type="range" class="input-line__range"
				step="10000" :min="min" :max="max" v-model.lazy="value"
				v-bind="$attrs"
			>
		`
	};

	const calculator = document.getElementById('calculator');
	if (calculator) {
		const mageCalc = {
			components: {
				'm-input': mInput
			},
			data() {
				return {
					default: 0,
					form: null,
					dom: {
						priceEl: null,
						formPopup: null,
						selectedCity: null,
						selectedFirst: null,
						selectedPercent: null,
						selectedAge: null,
						mageDataInput: null
					},
					mage: {
						percent: 0,
						sum: 0,
						monthPay: 0,
						price: 0,
						first: 0,
						body: 0,
						age: 0
					},
					firstMinLimit: 0,
					firstMinCurrent: 0,
					firstMaxLimit: 0,
					firstMaxCurrent: 0,
				}
			},
			watch: {
				'mage.price' : function() { 
					this.mage.price = this.mage.price.toString().replace(/\s/g, '');
					this.firstMinCurrent = this.mage.price * this.firstMinLimit / 100;
					this.firstMaxCurrent = this.mage.price * this.firstMaxLimit / 100;
					
					if (this.mage.first < this.firstMinCurrent) {
						this.mage.first = this.firstMinCurrent;
					}

					if (this.mage.first > this.firstMaxCurrent) {
						this.mage.first = this.firstMaxCurrent;
					}

					this.calculateMortage();
				},
				'mage.first' : function() {
					this.mage.first = this.mage.first.toString().replace(/\s/g, '');
					this.calculateMortage();
				},
				'mage.age' : function() {
					this.calculateMortage();
				}
			},
			mounted() {
				this.form = document.querySelector('.mage-calc__body');
				this.dom.formPopup = document.querySelector('.popup--mortage-steps');
				this.dom.selectedCity = document.getElementById('selectedCity');
				this.dom.selectedFirst = document.getElementById('selectedFirst');
				this.dom.selectedPercent = document.getElementById('selectedPercent');
				this.dom.selectedAge = document.getElementById('selectedAge');
				this.dom.mageDataInput = document.querySelector('.mage-else__mage-data-input');
				
				this.default = JSON.parse(this.form.dataset.default);

				this.mage.percent = parseFloat(this.default.percent);
				this.mage.price = parseInt(this.default.price);
				this.mage.first = parseInt(this.default.first);
				this.mage.age = parseInt(this.default.age*12);

				this.firstMinLimit = parseInt(this.default.firstMin);
				this.firstMaxLimit = parseInt(this.default.firstMax);

				// update vars after render
				calcForm = document.querySelector('.mage-calc__body');
				mageCalcResultWrp = document.querySelector('.mgcr');

				this.$nextTick(() => {
					this.calculateMortage();
				});
			},
			created() { },
			unmounted() {},
			methods: {
				renderSelectedInfo() {
					this.dom.selectedCity.textContent = document.querySelector('.js-selected-city').value;
					this.dom.selectedFirst.textContent = new Intl.NumberFormat('ru').format(this.mage.first) + ' руб';
					this.dom.selectedPercent.textContent = this.mage.percent + ' %';
					this.dom.selectedAge.textContent = this.mage.age / 12 + ' лет';
				},
				calculateMortage() {
					this.mage.body = this.mage.price - this.mage.first;

					let i, koef;
					i = (this.mage.percent / 12) / 100;
					koef = (i * (Math.pow(1 + i, this.mage.age))) / (Math.pow(1 + i, this.mage.age) - 1);

					this.mage.monthPay = this.mage.body * koef;
					this.mage.monthPay = this.mage.monthPay.toFixed();

					this.mage.body = new Intl.NumberFormat('ru').format(this.mage.body);
					this.mage.monthPay = new Intl.NumberFormat('ru').format(this.mage.monthPay);

					let formData = new FormData(this.form);
					this.dom.mageDataInput.value = JSON.stringify(Object.fromEntries(formData));

					this.renderSelectedInfo();
				},
				openMortageFormPopup() {
					this.renderSelectedInfo();

					pickedOffersInput.value = '';
					
					document.body.style.overflow = 'hidden';
					this.dom.formPopup.classList.add('popup--active');
				},
				updatePrograms(event) {
					
					// Filter range inputs because it dublicate text fields
					if (event.target.classList.contains('input-line__range')) {
						return;
					}

					updateProgramsNative(calcForm);
				},
				showGraphTable() {
					showGraphTableNative();
				}
			}
		}

		Vue.createApp(mageCalc).mount(calculator);

		initNewBuildingsSliders();
	}


	const bankWrp = document.getElementById('mageBank');
	if (bankWrp) {
		let miniForm = document.querySelector('.mage-calc__form--line');

		let map,
				markerArray = [],
				markers = L.markerClusterGroup(),
				complexIcon = new L.Icon({
					iconUrl: '/img/map-pin.svg',
					iconSize: [40, 40],
				});

		function renderBankBranches(branches) {

			branches.forEach(function(branch){
				let marker = L.marker([branch.lat,branch.lng], {
					icon: complexIcon
				});
				
				marker.bindPopup(branch.baloonHTML, {
					minWidth: 200,
					className: 'branch-baloon',
					closeButton: false
				});
		
				markers.addLayer(marker);
				markerArray.push(marker);
			});

			map.addLayer(markers);
			var group = L.featureGroup(markerArray);
			map.fitBounds(group.getBounds(), {
					padding: [15, 15]
			});
		}

		function initBankBranchesMap() {
			map = L.map(mapContainer).setView([mapContainer.dataset.lat, mapContainer.dataset.lng], 16);
			L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {attribution: 'Map data &copy; <a href=\"https://www.openstreetmap.org/\">OpenStreetMap</a> contributors, <a href=\"https://creativecommons.org/licenses/by-sa/2.0/\">CC-BY-SA</a>'}).addTo(map);

			let data = new FormData();
			data.append('city', mapContainer.dataset.city);
			data.append('bank', mapContainer.dataset.bank);

			fetch('/data/bank-branches.json', {
				method: 'post',
				body: data
			}).then(response => {
				return response.json();
			}).then(resp => {
				renderBankBranches(resp.branches);
			});
		}

		const mageBank = {
			components: {
				'm-input': mInput
			},
			data() {
				return {
					default: 0,
					programsCount: 0,
					step: 'first',
					dom: {
						selectedCity: null,
						selectedFirst: null,
						selectedPercent: null,
						selectedAge: null
					},
					mage: {
						type: 0,
						age: 0,
						price: 0,
						first: 0,
						incomeProof: 0,
						cat: 0,
						experience: 0,
						clientAge: 0,
						banks: 0,
						percent: 0
					},
					firstMinLimit: 0,
					firstMinCurrent: 0,
					firstMaxLimit: 0,
					firstMaxCurrent: 0,
				}
			},
			watch: {
				'mage.price' : function() { 
					this.mage.price = this.mage.price.toString().replace(/\s/g, '');
					this.firstMinCurrent = this.mage.price * this.firstMinLimit / 100;
					this.firstMaxCurrent = this.mage.price * this.firstMaxLimit / 100;
					
					if (this.mage.first < this.firstMinCurrent) {
						this.mage.first = this.firstMinCurrent;
					}

					if (this.mage.first > this.firstMaxCurrent) {
						this.mage.first = this.firstMaxCurrent;
					}
				},
				'mage.first' : function() {
					this.mage.first = this.mage.first.toString().replace(/\s/g, '');
				},
				'step' : function() {
					if (this.step == 'third') {
						this.renderSelectedInfo();
					}
				}
			},
			mounted() {
				miniForm = document.querySelector('.mage-calc__form--line');
				stepsPopup = document.querySelector('.popup--mortage-steps');
				mageOfferTables = document.querySelectorAll('.mage-offer');
				mapContainer = document.querySelector('.mpage__map');
				formPopup = document.querySelector('.popup--mortage-steps');

				this.dom.selectedCity = document.getElementById('selectedCity');
				this.dom.selectedFirst = document.getElementById('selectedFirst');
				this.dom.selectedPercent = document.getElementById('selectedPercent');
				this.dom.selectedAge = document.getElementById('selectedAge');
				
				this.default = JSON.parse(miniForm.dataset.default);

				this.mage.type = this.default.type;
				this.mage.price = parseInt(this.default.price);
				this.mage.first = parseInt(this.default.first);
				this.mage.percent = parseInt(this.default.percent);
				this.mage.age = parseInt(this.default.age*12);

				this.firstMinLimit = parseInt(this.default.firstMin);
				this.firstMaxLimit = parseInt(this.default.firstMax);

				this.$nextTick(() => {
					updatePickers();

					initSimpleForm(document.querySelector('.mage-else__form'));
				});

				initBankBranchesMap();
			},
			methods: {
				updatePrograms(event) {
					
					// Filter range inputs because it dublicate text fields
					if (event.target.classList.contains('input-line__range')) {
						return;
					}

					updateProgramsNative(miniForm);
				},
				getProgramsCount(data) {

					const countEl = stepsPopup.querySelector('.mage-lf__count');					
					countEl.classList.add('mage-lf__count--loading');

					fetch('/data/getMortageVariantsCount.json', {
						method: 'post',
						body: data
					}).then(response => {
						return response.json();
					}).then(data => {

						this.programsCount = data.count;						
						countEl.classList.remove('mage-lf__count--loading');
					});
				},
				openPopup(e) {
					e.preventDefault();

					this.step = 'first';
					this.getProgramsCount(new FormData(miniForm));
					updatePickers();					

					stepsPopup.classList.add('popup--active');
					document.body.style.overflow = 'hidden';
				},
				submitLargeForm(event) {
					event.preventDefault();

					const largeForm = event.target,
								submitBtn = largeForm.querySelector('.mage-lf__submit'),
								btnState = submitBtn.textContent;

					submitBtn.disabled = true;
					submitBtn.textContent = submitBtn.dataset.wait;

					fetch('/data/mortage-offers-popup.html', {
						method: 'post',
						body: new FormData(largeForm)
					}).then(response => {
						return response.text();
					}).then(html => {
						const  mageOffersPopupList = document.querySelector('.mage-md-wrp__container');
						mageOffersPopupList.innerHTML = html;
						this.step = 'second';

						submitBtn.disabled = false;
						submitBtn.textContent = btnState;
					});
				},
				prepareLastStep(event) {
					event.preventDefault();
					this.step = 'third';
				},
				renderSelectedInfo() {
					this.dom.selectedCity.textContent = document.querySelector('.js-selected-city').value;
					this.dom.selectedFirst.textContent = new Intl.NumberFormat('ru').format(this.mage.first) + ' руб';
					this.dom.selectedPercent.textContent = this.mage.percent + ' %';
					this.dom.selectedAge.textContent = this.mage.age / 12 + ' лет';
				},
			}
		}

		mageBankApp = Vue.createApp(mageBank).mount(bankWrp);
	}
});